import React, { useEffect, useState } from 'react'
import Table from '../Table/Table'
import Table_Buttons from '../Table_Button/Table_button'
import { toast } from 'react-toastify'
import { API } from '../../Redux/actions/API'
import Navbar from '../Navbar/Navbar'

function TrandingWithdrawHistory() {
  const [referralApi, setreferralApi] = useState([])
  const [leftreferralApi, setleftreferralApi] = useState([])
  const [search, setSearch] = useState("0")
  const [currentPage, setcurrentPage] = useState(1)
  // const [todate, setTodate] = useState('')
  const [listPerpage, setlistPerpage] = useState(10)
  const [currentPage2, setcurrentPage2] = useState(1)
  const [listPerpage2, setlistPerpage2] = useState(10)


  const referral_API = async () => {
    try {
      let responceRight = await API?.post('/getWithdrawalCancelHistoryadmin', {
        "uid": search
      })
      responceRight = responceRight.data.data[0]
      console.log('My_Team', responceRight)

      setleftreferralApi([])
      let arrayLeft = []
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index+1,
          id: `${item?.uid} `,
          radio: `${item?.Request_amount}`,
          req_date: `${item?.req_date}`,
          cancel_date: `${item?.cancel_date} `,
          remark: `${item?.Remark} `,
          admincharge:item?.admincharge,
          amount:item?.amount,
          wallet: `${item?.useraddress}`,

          // date: `${item?.paidDate} `,
          //   Req_date: `${item?.date} `,
          // txn: (
          //   <>
          //     <a href={`https://bscscan.com/tx/${item.txn}`} target="_blank">View Txn</a>
          //   </>
          // ),
          // bnb:`${item?.bnb50}`
        })

        setleftreferralApi(arrayLeft)
      })
    } catch (e) {
      console.log('Error While calling Myteam API', e)
    }
  }

  useEffect(() => {
    referral_API()
  }, [])

  const indexOfLastPost = currentPage * listPerpage
  const indexOfFirstPage = indexOfLastPost - listPerpage
  const indexOfLastPost2 = currentPage2 * listPerpage2
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost)
  const currentPostleft = leftreferralApi.slice(indexOfFirstPage2, indexOfLastPost2)

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: 'S.No.', accessor: 'sr' },
      { Header: 'User ID', accessor: 'id' },
      { Header: "Wallet Address", accessor: "wallet" },
      { Header: 'Request Amount', accessor: 'radio' },
      { Header: "Admin Charge", accessor: "admincharge" },
      { Header: "Pay Amount", accessor: "amount" },
      { Header: 'Requested Date & Time', accessor: 'req_date' },
      { Header: 'Cancel Date & Time', accessor: 'cancel_date' },
      // { Header: 'Withdrawal Drd', accessor: 'totalwith' },
      // { Header: 'Withdrawal BNB', accessor: 'bnb' },
      // { Header: 'Txn', accessor: 'txn' },
      { Header: 'Remark ', accessor: 'remark' },
     
    ],
  })

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            {/* <!-- Inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Cancel Withdrawal History</h4>
                  </div>
                  <div class="panel-body">
                    <form action="/Admin/BulkRegistration" method="post" class="ng-pristine in-ip-1 ng-valid">
                      <div class="form-inline" role="form">
                        <div class="col-md-12">
                          <div class="col-md-2">
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => setSearch(e.target.value)}
                              name="uid"
                              placeholder="Enter User Id"
                              type="text"
                            />
                          </div>
                          <div class="col-md-3 col-xs-12">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API()}
                              class="btn btn-sm btn-primary"
                              value="Search"
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">{/* <h4 class="panel-title">Total USD : {totalIncome}</h4> */}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: 'scroll' }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrandingWithdrawHistory
